<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <h1>{{ $t('sign_in') }}</h1>

                <div v-show="authenticationError" class="alert alert-danger">
                    <strong>{{ $t('failed2signin') }}</strong> {{ $t('failed2signinCheckCred') }}
                </div>
            </div>
            <div class="col-md-6 offset-md-3" :class="{ failure: error }">
                <form class="form" role="form" novalidate @submit.prevent="login">
                    <div class="form-group">
                        <label for="username">{{ $t('username') }}</label>
                        <input id="username" v-model="credentials.username" type="text" class="form-control" :placeholder="$t('username_placeholder')" />
                    </div>
                    <div class="form-group">
                        <label for="password">{{ $t('password') }}</label>
                        <input id="password" v-model="credentials.password" type="password" class="form-control" :placeholder="$t('password_placeholder')" />
                    </div>
                    <button type="submit" class="btn btn-primary">{{ $t('sign_in') }}</button>
                </form>
                <p></p>
                <div class="alert alert-warning">
                    <a class="alert-link" href="#/passwordreset">{{ $t('forgot') }}</a>
                </div>
                <div class="alert alert-warning">
                    {{ $t('noaccount') }} <br />
                    <a class="alert-link" href="#/register">{{ $t('register') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from '@/app/auth/auth.helpers';
import { email } from 'vuelidate/lib/validators';

export default {
    name: 'LoginPage',

    data() {
        return {
            passwordHidden: true,
            credentials: {
                username: null,
                password: null,
                rememberMe: true,
            },
            error: false,
            loading: false,
            authenticationError: false,
        };
    },
    validations() {
        return {
            credentials: {
                username: {
                    email,
                },
            },
        };
    },
    methods: {
        login() {
            this.loading = true;

            const credentials = {
                username: this.credentials.username.toLowerCase(),
                password: this.credentials.password,
                rememberMe: this.credentials.rememberMe,
            };

            auth.login(credentials, 'home', (isSuccess) => {
                this.authenticationError = !isSuccess;
                this.error = !isSuccess;
                if (!isSuccess) {
                    setTimeout(this.removeClass, 1000);
                }
                this.loading = false;
            });
        },
        removeClass() {
            this.error = false;
        },
    },
};
</script>

<style>
.failure {
    -webkit-animation: shake 0.4s 1 linear;
    -moz-animation: shake 0.4s 1 linear;
    -o-animation: shake 0.4s 1 linear;
    animation: shake 0.4s 1 linear;
}

@keyframes shake {
    0% {
        transform: translate(30px);
    }
    20% {
        transform: translate(-30px);
    }
    40% {
        transform: translate(15px);
    }
    60% {
        transform: translate(-15px);
    }
    80% {
        transform: translate(8px);
    }
    100% {
        transform: translate(0px);
    }
}

@-webkit-keyframes shake {
    0% {
        -webkit-transform: translate(30px);
    }
    20% {
        -webkit-transform: translate(-30px);
    }
    40% {
        -webkit-transform: translate(15px);
    }
    60% {
        -webkit-transform: translate(-15px);
    }
    80% {
        -webkit-transform: translate(8px);
    }
    100% {
        -webkit-transform: translate(0px);
    }
}

@-moz-keyframes shake {
    0% {
        -moz-transform: translate(30px);
    }
    20% {
        -moz-transform: translate(-30px);
    }
    40% {
        -moz-transform: translate(15px);
    }
    60% {
        -moz-transform: translate(-15px);
    }
    80% {
        -moz-transform: translate(8px);
    }
    100% {
        -moz-transform: translate(0px);
    }
}

@-o-keyframes shake {
    0% {
        -o-transform: translate(30px);
    }
    20% {
        -o-transform: translate(-30px);
    }
    40% {
        -o-transform: translate(15px);
    }
    60% {
        -o-transform: translate(-15px);
    }
    80% {
        -o-transform: translate(8px);
    }
    100% {
        -o-origin-transform: translate(0px);
    }
}
</style>

<!-- language=json -->
<i18n>
{
    "de": {
        "sign_in": "Anmeldung",
        "username": "Benutzername / Email",
        "password": "Kennwort",
        "username_placeholder": "Ihr Benutzername / Email",
        "password_placeholder": "Ihr Passwort",
        "newpassword": "Neues Kennwort",
        "newpassword_placeholder": "Neues Kennwort",
        "confirmpassword": "Neues Kennwort bestätigen",
        "confirmpassword_placeholder": "Bestätigen Sie Ihr neues Kennwort",
        "email": "E-Mail Adresse",
        "email_placeholder": "Ihre E-Mail Adresse",
        "remember_me": "Automatische Anmeldung",
        "forgot": "Kennwort vergessen?",
        "noaccount": "Sie haben noch kein Konto?",
        "register": "Jetzt ausprobieren und Benutzerkonto anlegen.",
        "failed2signin": "Anmeldung fehlgeschlagen!",
        "failed2signinCheckCred": "Bitte überprüfen Sie Ihre Zugansgdaten."
    },
    "en": {
        "sign_in": "Sign in!",
        "username": "Username / Email",
        "password": "Password",
        "username_placeholder": "Your username / Email",
        "password_placeholder": "Your password",
        "newpassword": "New password",
        "newpassword.placeholder": "New password",
        "confirmpassword": "New password confirmation",
        "confirmpassword_placeholder": "Confirm the new password",
        "email": "E-mail",
        "email_placeholder": "Your e-mail",
        "remember_me": "Remember me",
        "forgot": "Did you forget your password?",
        "noaccount": "You don't have an account yet?",
        "register": "Try it and register an account.",
        "failed2signin": "Failed to sign in!",
        "failed2signinCheckCred": "Please check your credentials and try again."
    }
}
</i18n>
